import { type SupportedLocale } from '@reward-platform/platform-config'

export const DEFAULT_LOCALE: SupportedLocale = 'en-GB'
